<template>
    <div :class="classes" data-flex="row root">
        <skip-link>Skip to main content</skip-link>

        <cookie-popup :text="cookieText"></cookie-popup>
        
        <main-menu></main-menu>
        
        <main-header></main-header>

        <keep-alive exclude="Stories">
            <router-view></router-view>
        </keep-alive>
    </div>
</template>

<script>
import MainMenu from '@/components/MainMenu'
import MainHeader from '@/components/MainHeader'
import CookiePopup from '@/components/Ui/CookiePopup'

import { isStoryPage, isStaticPage } from '@/data/pages'
import { resize } from '@/mixins/resize'

export default {
    name: 'App',

    props: {
        cookieText: {
            type: String,
            default: 'Doane Grant Thornton uses cookies to monitor the performance of this website and improve user experience.'
        },
    },
    
    metaInfo: {
        title: 'Discover Your Purple',
        titleTemplate: 'Doane Grant Thornton | %s'
    },
    
    components: {
        MainMenu,
        MainHeader,
        CookiePopup,
        SkipLink: () => import(/* webpackChunkName: "skip-link-btn" */ '@/components/Ui/SkipLink'),
    },
    
    created() {
        this.handleSplashPreload()
        this.$store.dispatch('initialLoad').then(() => {
            this.handleIePopups()
            this.rootClass('rm', 'no-js')
        })
    },
    
    computed: {
        classes() {
            const { path } = this.$route
            const { type } = this.$store.getters.user
            let classListString = `main path-${type}`

            isStoryPage(path) &&  (classListString += ' page-story')
            isStaticPage(path) &&  (classListString += ' page-static')
            
            return classListString
        },
    },

    mixins: [
        resize,
    ],

    methods: {
        handleIePopups() {
            const popups = [
                document.getElementById('ie'),
                document.getElementById('edge'),
            ]
            popups.forEach(popup => popup && popup.remove())
        },
        
        handleSplashPreload() {
            const link = document.createElement('link')
            link.rel = 'preload'
            link.as = 'image'
            link.href = require(`@/assets/img/purple-splash.png`)

            document.head.appendChild(link)
        },
    }
}
</script>

<style lang="scss">
    @import 'assets/styles/sheet.scss'
</style>
